;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { StocklistSourceStatus } from '@qogita/canary-client'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Button } from '@qogita/ui/v2/button'
import { ButtonIcon } from '@qogita/ui/v2/button-icon'
import { CopyButton } from '@qogita/ui/v2/copy-button'
import { Icon } from '@qogita/ui/v2/icon'
import { InlineNotification } from '@qogita/ui/v2/inline-notification'
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
} from '@qogita/ui/v2/modal'

export function IngestionBanner({
  stocklistSourceStatus,
  isSellerUsingSos,
  isSellerWithCustomIntegration,
}: {
  stocklistSourceStatus: StocklistSourceStatus
  isSellerUsingSos: boolean
  isSellerWithCustomIntegration: boolean
}) {
  if (!stocklistSourceStatus.hasError) {
    return null
  }

  const isSellerSOSorCustomIntegration = Boolean(
    isSellerUsingSos || isSellerWithCustomIntegration,
  )
  const isSellerUsingFTPOrURL = Boolean(
    stocklistSourceStatus.stocklistSourceType === 'ftp' ||
    stocklistSourceStatus.stocklistSourceType === 'url',
  )

  return (
    <div className="bg-error-900 flex w-full items-center justify-center gap-4 px-4 py-2.5 text-white">
      <Icon
        name="heroicons/outline/exclamation-triangle"
        className="size-4.5"
      />
      <span className="text-center text-sm font-medium">
        Price list error. Your offers are not visible to buyers until this issue
        is resolved.
      </span>
      {isSellerSOSorCustomIntegration ? (
        <SosAndCustomIntegrationErrorModal
          message={stocklistSourceStatus.message ?? 'An error occurred'}
          errorCode={stocklistSourceStatus.errorCode || 'UNKNOWN'}
        />
      ) : isSellerUsingFTPOrURL ? (
        <NonSosErrorModal
          message={stocklistSourceStatus.message ?? 'An error occurred'}
          errorCode={stocklistSourceStatus.errorCode || 'UNKNOWN'}
        />
      ) : (
        <EmailIngestionErrorModal
          message={stocklistSourceStatus.message ?? 'An error occurred'}
        />
      )}
    </div>
  )
}

function EmailIngestionErrorModal({ message }: { message: string }) {
  return (
    <Modal>
      <ModalTrigger asChild>
        <Button
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="font-normal whitespace-nowrap hover:text-gray-50"
          variant="inline-text"
          size="small"
        >
          Resolve now
          <ButtonIcon name="heroicons/solid/arrow-right" />
        </Button>
      </ModalTrigger>

      <ModalContent>
        <ModalHeader>
          {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
          <ModalTitle className="flex items-center gap-3">
            <Icon
              name="heroicons/outline/exclamation-triangle"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="text-error-700"
            />
            Price list error
          </ModalTitle>
        </ModalHeader>
        {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
        <ModalBody className="flex flex-col gap-4">
          <InlineNotification
            theme="error"
            emphasis="low"
            icon={null}
            message={message}
          />
          <p className="font-light text-gray-700">
            Resolve this issue and{' '}
            <span className="font-normal">resend the stock</span> to avoid order
            disruptions. Changes may take up to 15 mins to update.
          </p>
        </ModalBody>
        <ModalFooter>
          <ModalClose asChild>
            <Button>Okay</Button>
          </ModalClose>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

function NonSosErrorModal({
  errorCode,
  message,
}: {
  errorCode: string
  message: string
}) {
  return (
    <Modal>
      <ModalTrigger asChild>
        <Button
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="font-normal whitespace-nowrap hover:text-gray-50"
          variant="inline-text"
          size="small"
        >
          Resolve now
          <ButtonIcon name="heroicons/solid/arrow-right" />
        </Button>
      </ModalTrigger>

      <ModalContent>
        <ModalHeader>
          {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
          <ModalTitle className="flex items-center gap-3">
            <Icon
              name="heroicons/outline/exclamation-triangle"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="text-error-700"
            />
            Price list error
          </ModalTitle>
        </ModalHeader>
        {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
        <ModalBody className="flex flex-col gap-4">
          <InlineNotification
            theme="error"
            emphasis="medium"
            icon={null}
            title={message}
            message={
              <>
                {errorCode} <CopyButton textToCopy={errorCode} />
              </>
            }
          />
          <p className="font-light text-gray-700">
            Update your settings on the portal. If the issue is not resolved,{' '}
            <span className="font-normal">
              escalate this error to your technical team
            </span>{' '}
            to avoid order disruptions.
          </p>
        </ModalBody>
        <ModalFooter>
          <ModalClose asChild>
            <Anchor href="/integrations/stock-ingestion">
              Update settings
            </Anchor>
          </ModalClose>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

function SosAndCustomIntegrationErrorModal({
  errorCode,
  message,
}: {
  errorCode: string
  message: string
}) {
  return (
    <Modal>
      <ModalTrigger asChild>
        <Button
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="font-normal whitespace-nowrap hover:text-gray-50"
          variant="inline-text"
          size="small"
        >
          Resolve now
          <ButtonIcon name="heroicons/solid/arrow-right" />
        </Button>
      </ModalTrigger>

      <ModalContent>
        <ModalHeader>
          {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
          <ModalTitle className="flex items-center gap-3">
            <Icon
              name="heroicons/outline/exclamation-triangle"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="text-error-700"
            />
            Price list error
          </ModalTitle>
        </ModalHeader>
        {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
        <ModalBody className="flex flex-col gap-4">
          <InlineNotification
            theme="error"
            emphasis="medium"
            icon={null}
            title={message}
            message={
              <>
                {errorCode} <CopyButton textToCopy={errorCode} />
              </>
            }
          />
          <p className="font-light text-gray-700">
            Escalate this error to your technical team to avoid order
            disruptions. Resolve this issue or{' '}
            <Anchor
              href="mailto:supplier-integrations@qogita.com"
              variant="inline-text"
            >
              reach out to us
            </Anchor>{' '}
            with updated API instructions.
          </p>
        </ModalBody>
        <ModalFooter>
          <ModalClose asChild>
            <Button>Okay</Button>
          </ModalClose>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
